import React from "react";
import SelectBox from "./QuestionComponent/SelectBox";
import DoNotAllowReSubmissionSelect from "./QuestionComponent/DoNotAllowReSubmissionSelect";
import DoNotAllowReSubmissionChoice from "./QuestionComponent/DoNotAllowReSubmissionChoice";
import MultiSelectComponent from "./QuestionComponent/MultiSelectComponent";
import VSNDropDown from "./QuestionComponent/VSNDropDown";
import InputField from "./QuestionComponent/InputField";
import SingleLineSelect from "./QuestionComponent/SingleLineSelect";
import VSNSelectDropDown from "./QuestionComponent/VSNSelectDropDown";
import StaticQuestion from "./QuestionComponent/StaticQuestion";
import DateInputField from "./QuestionComponent/DateInputField";
import SingleLineAnswer from "./QuestionComponent/SingleLineAnswer";
import CheckBox from "./QuestionComponent/CheckBox";
import ToggleComponent from "./QuestionComponent/ToggleButton";
import PrescriptionMedication from "./QuestionComponent/MedicalQuestionnaire/PrescriptionMedication";
import RadioButtonSelect from "./QuestionComponent/RadioButtonSelect";
import FamilyHistoryTable from "./QuestionComponent/MedicalQuestionnaire/FamilyHistoryTable";
import OptionalInputField from "./QuestionComponent/OptionalInputField";
import NumberOrNone from "./QuestionComponent/NumberOrNone";
import ParentQuestion from "./QuestionComponent/ParentQuestion";
import SubMultiSelect from "./QuestionComponent/SubMultiSelect";

const CustomQuestion = ({
  question,
  onChange,
  value,
  handelNextQuestion,
  currentQuestionIndex,
  allow_resubmission,
  onChangeMultiChoice,
  assessmentFormData,
}) => {
  switch (question?.answer_type) {
    case "text":
    case "number":
      return (
        <InputField
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "number_or_none":
      return (
        <NumberOrNone
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "text-optional":
      return (
        <OptionalInputField
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "date":
      return (
        <DateInputField
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "single-option":
      return (
        <DoNotAllowReSubmissionSelect
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "single-choice":
      if (!allow_resubmission) {
        return (
          <DoNotAllowReSubmissionChoice
            {...{
              question,
              onChange,
              value,
              handelNextQuestion,
              currentQuestionIndex,
              allow_resubmission,
            }}
          />
        );
      }
      return (
        <SelectBox
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "single-line-choice":
      return (
        <SingleLineSelect
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "parent-question":
      return (
        <ParentQuestion
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            assessmentFormData,
            onChangeMultiChoice,
          }}
        />
      );
    case "single-line-answer":
      return (
        <SingleLineAnswer
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "multiple-choice":
    case "multiple-choice-optional":
      return (
        <MultiSelectComponent
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "sub-question":
      return (
        <SubMultiSelect
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "dropdown":
      return (
        <VSNDropDown
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "select-dropdown":
      return (
        <VSNSelectDropDown
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "static-json":
      return (
        <StaticQuestion
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "checkbox":
      return (
        <CheckBox
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "toggle-button":
      return (
        <ToggleComponent
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
            onChangeMultiChoice,
          }}
        />
      );
    case "A24-form":
      return (
        <PrescriptionMedication
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    case "radio-button":
      return (
        <RadioButtonSelect
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );

    case "A24-family-history-form":
      return (
        <FamilyHistoryTable
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
    default:
      return (
        <SingleLineSelect
          {...{
            question,
            onChange,
            value,
            handelNextQuestion,
            currentQuestionIndex,
            allow_resubmission,
          }}
        />
      );
  }
};

export default CustomQuestion;
